import axios from 'axios';
import config from '../config';

export async function searchProduct(data: any) {
  if (!data) return;
  try {
    const res = await axios.post(`${config.baseUrl}/api/v2/med-link/common/getProductByCondition`, data);
    return Promise.resolve(res.data);
  } catch (error) {
    console.log(error);
  }
}

export async function getProductById(item_id: string) {
  if (!item_id || item_id.trim() == '') return;
  try {
    const res = await axios.get(`${config.baseUrl}/api/v2/med-link/common/getProductById/${item_id}`);
    return Promise.resolve(res.data);
  } catch (error) {
    console.log(error);
  }
}

export async function checkStock(data: any) {
  if (!data) return;
  try {
    const res = await axios.post(`${config.baseUrl}/api/v2/med-link/common/checkStock`, data);
    return Promise.resolve(res.data);
  } catch (error) {
    console.log(error);
  }
}
